// extracted by mini-css-extract-plugin
export default {"errorDisplay":"ErrorDisplay_errorDisplay__q2azS"};